/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Payment View Model
    // Holds Payment Processing Information
    /**************************************/
    function PaymentViewModel() {

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.AccountTypeID = ko.validatedObservable();
        this.CardNumber = ko.validatedObservable();
        this.ExpirationDate = ko.validatedObservable();
        this.CCV = ko.validatedObservable();
        this.FirstName = ko.validatedObservable();
        this.LastName = ko.validatedObservable();
        this.CouponCode = ko.validatedObservable();

        this.UsesMailingAddress = ko.observable(true);
        this.BillingAddress = ko.validatedObservable(new sm.portal.vm.MailingAddressViewModel());

        this.BillingAddressDataLoaded = ko.observable(false);

        this.IsRequired = ko.observable(false);
        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("PaymentContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        /*** COMPUTED PROPERTIES ***/
        this.CardNumberMasked = ko.computed(function () {

            var masked = this.CardNumber();
            if (!sm.portal.utility.isNullOrEmpty(masked)) {
                masked = masked.trim();
                masked = masked.substr(masked.length - 4);

                masked = '****-****-****-' + masked;

                return masked;
            }
            return '';
        }, this);
        this.AnythingPopulated = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.AccountTypeID())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.CardNumber())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.ExpirationDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.CCV())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.FirstName())) return true;
            if (!sm.portal.utility.isNullOrEmpty(this.LastName())) return true;
            return false;
        }, this);       
        /***  COMPUTED PROPERTIES ***/

    

        /*** METHODS ***/
        this.UseMailingAddressChanged = function () {
            var basicContactModel = viewModel.GetSectionModel('BasicContact');

            if (basicContactModel != null && !sm.portal.utility.isNullOrEmpty(self.UsesMailingAddress())) {
                if (self.UsesMailingAddress()) {
                    // copy data from Primary Mailing Address
                    self.BillingAddress().LoadAddressModelFromAddressModel(basicContactModel.PrimaryMailingAddress());

                } else {
                    // Clear Data completely.
                    self.BillingAddress().LoadAddressModelFromAddressModel(new sm.portal.vm.MailingAddressViewModel());

                }
            }
            return true;
        };
        /*** METHODS ***/

        /*** SECTION METHODS ***/
        this.Initialize = function () {

            // Bring in the Names 
            var personSecData = viewModel.GetSectionModel('BasicPerson');
            this.FirstName(personSecData.FirstName());
            this.LastName(personSecData.LastName());

            // Check the UsesMailingAddress and load data if necesary
            self.UseMailingAddressChanged();
        };
        this.LoadModel = function (container) {

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[PaymentVM] Data Loaded'); }
        };
        this.GetModelData = function (blockui, applicationMID, personMID) {

            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=payment&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                    }
                });
            }
        };
        this.CheckInclusion = function (applicationMID, personMID) {

            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=payment&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Payment: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'Payment', required: false });
                                self.IsRequired(false);
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'Payment', required: true });
                                self.IsRequired(true);
                                break;
                            case "Exclude":
                                sectionsToRemove.push('Payment');
                                self.IsRequired(false);
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {

            if (!this.UsesMailingAddress()) {   // Only submit if it's different.

                // Submit an entered address to the server to construct TEXT and HTML Values
                var data = this.BillingAddress().ExtractATO();

                var url = _baseApiUri + 'api/studentportal/processaddress';
                jQuery.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(data),
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                        if (data.Status == 'success') {

                            // Set the HTML and Text Values
                            var encodedAddress = container.Payload.HTMLValue;
                            if (!sm.portal.utility.isNullOrEmpty(encodedAddress)) {
                                self.BillingAddress().AddressHtmlValue(encodedAddress.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
                            } else {
                                self.BillingAddress().AddressHtmlValue('');
                            }
                            self.BillingAddress().AddressTextValue(container.Payload.TEXTValue);
                        }
                    },
                    error: function (jqXHR, exception) {

                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.UnBlockContainer();
                    }
                });
            }
        };
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new smapi.admissions.AdmissionsPaymentInformationModel({
                AccountTypeID: self.AccountTypeID(),
                FirstName: self.FirstName(),
                SurName: self.LastName(),
                CardNumber: self.CardNumber(),
                Expiration: self.ExpirationDate(),
                VerificationCode: self.CCV(),
                UseApplicationAddress: self.UsesMailingAddress()
            });
        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/
        this.AccountTypeID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CardNumber.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            //TODO Pattern based on CC Type
            //pattern: {
            //    params: ,
            //    message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            //}
        });
        this.ExpirationDate.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        //    date: {
        //        params: true,
        //        message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
        //    }
        });
        this.CCV.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 3,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '3')
            }
        });
        this.FirstName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.LastName.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {

            var isCompleted = true;
            if (!this.IsRequired()) {
                return isCompleted;
            }
            isCompleted = this.IsVMValid();
            if (!this.BillingAddress().IsVMValid()) isCompleted = false;

            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/


        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        PaymentViewModel: PaymentViewModel,
    });

})(jQuery);